export const CLASS_ARTICLE_SUBSCRIPTION_HEADLINE = 'subscription__headline';
export const CLASS_ARTICLE_SUBSCRIPTION_LOGIN = 'subscription__login';

const ArticleSubscription = () => {
  /**
   * Text, kterým bude nahrazen headline předplatného.
   */
  const rewriteSourceDiv: HTMLDivElement | null = document.querySelector(
    '[data-subscription-headline-rewrite]'
  );

  /**
   * Nahrazení headline předplatného.
   * (TPL: /default/artobj/subscription-headline-rewrite.twig)
   */
  if (rewriteSourceDiv) {
    const { subscriptionHeadlineRewrite } = rewriteSourceDiv.dataset;

    if (subscriptionHeadlineRewrite) {
      const headline = document.querySelector<HTMLElement>(
        `.${CLASS_ARTICLE_SUBSCRIPTION_HEADLINE}`
      );

      if (headline) headline.innerHTML = subscriptionHeadlineRewrite;
    }
  }

  /**
   * Skrytí přihlašovacího odkazu pro přihlášené (bez předplatného).
   */
  const isLoggedIn: boolean = CNC ? CNC.isLoggedIn : false;

  if (isLoggedIn) {
    const loginElement = document.querySelector<HTMLDivElement>(
      `.${CLASS_ARTICLE_SUBSCRIPTION_LOGIN}`
    );

    if (loginElement) {
      loginElement.style.display = 'none';
    }
  }
};

export default ArticleSubscription;
